<template>
  <div class="page-card">
    <el-card>
      <div slot="header">用户管理</div>
      <el-form :inline="true" size="small" @submit.native.prevent>
        <el-form-item label="手机号">
          <el-input v-model="query.phone" placeholder="手机号" />
        </el-form-item>
        <el-form-item label="车牌号">
          <el-input v-model="query.licensePlate" placeholder="车牌号" />
        </el-form-item>
        <el-form-item label="会员等级">
          <el-select v-model="query.level" clearable placeholder="全部">
            <el-option label="普通会员" value="普通会员" />
            <el-option label="黄金会员" value="黄金会员" />
            <el-option label="钻石会员" value="钻石会员" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="fetchList">查询</el-button>
          <el-button @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="list" border stripe>
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column prop="phone" label="手机号" />
        <el-table-column prop="licensePlate" label="车牌号" />
        <el-table-column prop="name" label="姓名" />
        <el-table-column prop="level" label="会员等级" />
        <el-table-column prop="points" label="积分" />
        <el-table-column prop="status" label="状态" />
        <el-table-column label="操作" width="340">
          <template slot-scope="scope">
            <el-button size="mini" @click="viewDetail(scope.row)">详情</el-button>
            <el-button size="mini" @click="changeLevel(scope.row)">调整等级</el-button>
            <el-button size="mini" @click="changePoints(scope.row)">调整积分</el-button>
            <el-button
              size="mini"
              type="danger"
              @click="toggleStatus(scope.row)"
            >
              {{ scope.row.status === '正常' ? '冻结' : '解冻' }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div style="text-align:right;margin-top:16px;">
        <el-pagination
          layout="prev, pager, next, total"
          :total="total"
          :page-size="query.pageSize"
          :current-page.sync="query.page"
          @current-change="fetchList"
        />
      </div>

      <el-dialog
        title="用户详情"
        :visible.sync="detailVisible"
        width="800px"
      >
        <el-descriptions :column="2" size="small" v-if="currentUser">
          <el-descriptions-item label="ID">{{ currentUser.id }}</el-descriptions-item>
          <el-descriptions-item label="手机号">{{ currentUser.phone }}</el-descriptions-item>
          <el-descriptions-item label="车牌号">{{ currentUser.licensePlate }}</el-descriptions-item>
          <el-descriptions-item label="会员等级">{{ currentUser.level }}</el-descriptions-item>
          <el-descriptions-item label="积分">{{ currentUser.points }}</el-descriptions-item>
        </el-descriptions>
        <el-divider>持有优惠券</el-divider>
        <el-table
          :data="currentUserCoupons"
          size="small"
          border
        >
          <el-table-column prop="name" label="名称" />
          <el-table-column prop="category" label="类型" />
          <el-table-column prop="price" label="面额" />
          <el-table-column prop="discount" label="折扣" />
          <el-table-column prop="expireDate" label="有效期至" />
          <el-table-column prop="status" label="状态" />
        </el-table>
      </el-dialog>

      <el-dialog
        title="调整会员等级"
        :visible.sync="levelDialogVisible"
        width="360px"
      >
        <el-form :model="levelForm" label-width="80px">
          <el-form-item label="会员等级">
            <el-select v-model="levelForm.level" placeholder="请选择等级" style="width: 100%;">
              <el-option label="普通会员" value="普通会员" />
              <el-option label="黄金会员" value="黄金会员" />
              <el-option label="钻石会员" value="钻石会员" />
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="levelDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitLevel">确 定</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import request from '@/api/request'

export default {
  name: 'UserList',
  data() {
    return {
      query: {
        phone: '',
        licensePlate: '',
        level: '',
        page: 1,
        pageSize: 10
      },
      list: [],
      total: 0,
      detailVisible: false,
      currentUser: null,
      currentUserCoupons: [],
      levelDialogVisible: false,
      levelForm: {
        id: null,
        level: ''
      }
    }
  },
  created() {
    this.fetchList()
  },
  methods: {
    fetchList() {
      request
        .get('/users', { params: this.query })
        .then(res => {
          const data = res.data || res
          this.list = (data && data.items) || []
          this.total = (data && data.total) || 0
        })
    },
    resetQuery() {
      this.query.phone = ''
      this.query.licensePlate = ''
      this.query.level = ''
      this.query.page = 1
      this.fetchList()
    },
    changePoints(row) {
      this.$prompt('请输入积分变动值（如 +100 或 -50），或直接输入最终积分（如 500）', '调整积分', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPlaceholder: '+100 / -50 / 500',
        inputPattern: /^\s*[-+]?\d+\s*$/,
        inputErrorMessage: '请输入整数'
      })
        .then(({ value }) => {
          const v = String(value || '').trim()
          let payload = {}
          if (!v) {
            this.$message.warning('输入不能为空')
            return
          }
          if (v.startsWith('+') || v.startsWith('-')) {
            payload = { delta: parseInt(v, 10) }
          } else {
            payload = { points: parseInt(v, 10) }
          }
          request.put(`/users/${row.id}/points`, payload).then(() => {
            this.$message.success('积分已更新')
            this.fetchList()
          })
        })
        .catch(() => {})
    },
    viewDetail(row) {
      request.get(`/users/${row.id}`).then(res => {
        const data = res.data || res
        this.currentUser = data.user
        this.currentUserCoupons = data.coupons || []
        this.detailVisible = true
      })
    },
    changeLevel(row) {
      this.levelForm = {
        id: row.id,
        level: row.level || '普通会员'
      }
      this.levelDialogVisible = true
    },
    submitLevel() {
      if (!this.levelForm.id || !this.levelForm.level) {
        this.$message.warning('请选择会员等级')
        return
      }
      request
        .put(`/users/${this.levelForm.id}/level`, { level: this.levelForm.level })
        .then(() => {
          this.$message.success('调整成功')
          this.levelDialogVisible = false
          this.fetchList()
        })
    },
    toggleStatus(row) {
      const target = row.status === '正常' ? '冻结' : '正常'
      this.$confirm(`确认将该账号状态调整为【${target}】吗？`, '提示', {
        type: 'warning'
      }).then(() => {
        request.put(`/users/${row.id}/status`, { status: target }).then(() => {
          this.$message.success('操作成功')
          this.fetchList()
        })
      })
    }
  }
}
</script>

